export const CENTER_EDUTALK = 1;
export const CENTER_DOI_TAC = 0;

export const ECOACH = 295;
export const IELTS = 516;
export const TOEIC = 518;
export const CAMBRIDGE = 530;
export const IELTS_CAMBRIDGE = 530;
export const ANU = 484;
export const MENTER_ENGLISH_MASTERY = 532;

export const WARRANTY_SERVICE_CENTERS = [ECOACH, IELTS, MENTER_ENGLISH_MASTERY];

export function isWarrantyServiceCenter(centerId) {
    return WARRANTY_SERVICE_CENTERS.includes(Number(centerId));
}

// branch id
export const LE_THANH_NGHI = 205;
export const PHAM_TUAN_TAI = 196;
export const TRAN_QUOC_VUONG = 228;

export const PILOT_BRANCH = [205,196]

export function isPilotEntrance(branchId) {
    return PILOT_BRANCH.includes(Number(branchId));
}
